/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconFiletypeFolderExcel = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M10 4h2.74L10 1.26V4zm-1.493 6.039l2.439 3.406H9.891L8.27 11.146a10.129 10.129 0 0 1-.282-.43c-.143.235-.246.395-.307.482l-1.618 2.247H5.04l2.491-3.358-2.197-3.085h1.015l1.169 1.653c.243.342.416.606.519.791a8.12 8.12 0 0 1 .509-.734l1.297-1.71h.927l-2.263 3.037zM14 15.557V5.001h-4c-.646 0-1-.438-1-1v-3H4a2 2 0 0 0-2 2v12.556c0 .245.198.443.443.443h11.114a.443.443 0 0 0 .443-.443z"
    />
  </svg>
);

IconFiletypeFolderExcel.displayName = 'IconFiletypeFolderExcel';

IconFiletypeFolderExcel.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconFiletypeFolderExcel);
IconFiletypeFolderExcel.displayName = 'IconFiletypeFolderExcel';
